export default __webpack_public_path__ + "static/media/editar.877c35ae.svg";